// src/AdminRoute.js
import { Navigate } from "react-router-dom";

export default function AdminRoute({ user, children }) {
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
